export const ROLES_USER = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  USER_PIECEWORK: 3,
  USER_ASSISTANCE: 4
}
